import authFlags from '@/utils/flags/auth'
import actions from './authActions'
import { getFlag } from '../utils/getters'

export const initialState = {
    authenticated: false,
    token: null,
}

export const mutations = {
    CLEAN (state) {
        Object.assign(state, initialState)
    },
    SET_AUTH (state, token) {
        state.authenticated = true
        state.token = { ...token }
    },
}

export const getters = {
    isAuth: state => state.authenticated,
    isAdmin: state => true,
    isLoading: (state, g, rootState) => getFlag(rootState, authFlags.LOADING),
}

export default {
    namespaced: true,
    state: {
        ...initialState,
    },
    actions,
    getters,
    mutations,
}
